<template>
    <div
        class="air-container air-container-subscribe-secret-pop"
        :class="[
            showAir ? 'air-container_active' : '',
            'air-container-email-subscription',
        ]"
    >
        <div class="popup-air" :class="showAir ? 'popup-air_active' : ''">
            <div class="air-close" @click="close()"></div>
            <EmailSubscriptionContent @subscribed="close" />
        </div>
    </div>
</template>

<script>
import store from '../../store.js';
import EmailSubscriptionContent from './EmailSubscriptionContent.vue';

export default {
    name: 'EmailSubscription',
    components: { EmailSubscriptionContent },
    data() {
        return {
            timeoutRu: 15,
            timeoutWorld: 15,
            pause: 86400,
            timer: null,
            data: null,
            unwatch: null,
        }
    },
    mounted() {
        if (this.isSubscribePage) {
            store.commit('closeEmailSubscriptionAir')
            store.commit('resetTime')
            return
        }
        this.data = JSON.parse(localStorage.getItem('email-subscription-air-1'))

        this.scheduleSubscriptionPopup()
    },
    watch: {
        showAir(value) {
            if (value === false) {
                clearInterval(this.timer)
            }
        }
    },
    computed: {
        isSubscribePage() {
            return /\/subscribe\/?$/.test(window.location.pathname)
        },
        time() {
            return this.$store.state.time
        },
        showAir() {
            return this.$store.state.showEmailSubscriptionAir
        },
        subscriptionTimeout() {
            return this.$store.state.settings.site_id === 1 ? this.timeoutRu : this.timeoutWorld
        }
    },
    methods: {
        scheduleSubscriptionPopup() {
            if (!this.data) {
                this.startTimer()
            }

            if (this.data) {
                if ((Date.now() - this.data.time) > (this.pause * 1000)) {
                    this.startTimer()
                }
            }
        },
        startTimer() {
            this.timer = setInterval(function() {
                store.commit('increaseTime')
            }, 1000)
            this.unwatch = this.$watch('time', (value) => {
                if (value === this.subscriptionTimeout) {
                    store.commit('openEmailSubscriptionAir')
                }
            })
        },
        close() {
            store.commit('closeEmailSubscriptionAir')
            store.commit('resetTime')
            if (this.unwatch) {
                this.unwatch()
            }
            if (!this.data) {
                localStorage.setItem('email-subscription-air-1', JSON.stringify({
                    'time': Date.now()
                }))
            }
            if (this.data && this.data.time) {
                localStorage.setItem('email-subscription-air-1', JSON.stringify({
                    'time': new Date().setFullYear(9999).toFixed()
                }))
            }
        },
    }
};
</script>

<style lang="scss">
.air-container-subscribe-secret-pop {
    .popup-air {
        padding: 20px;
        .air-close {
            top: 10px;
            right: 10px;
        }
    }
}
.air-container-email-subscription {
    .popup-air {
        background: #F7F6F9;
        .subscription-modal {
            background-color: #F7F6F9;
        }
    }
}
@media screen and (max-width: 768px) {
    .air-container-subscribe-secret-pop {
        .popup-air {
            margin: 0 20px;
        }
    }
}
</style>
